import {$} from '../utils';

// Project List Component
const ProjectList = () => {
    // Getting main slider
    let slider = document.querySelector('#project-vertical-slider-1');

    // Getting reverse slider
    let reverseSlider = document.querySelector('#project-vertical-slider-2');

    // Getting all slides
    let slides = document.querySelectorAll('#project-vertical-slider-1 > div');

    // Getting filter list
    let filterList = document.querySelectorAll('#filter-list button');

    // New Swiper
    const mobileSlider = new Swiper(".projectMobileSlider", {
        slidesPerView: 1.2,
            spaceBetween: 30,
            centeredSlides: true,
            noSwiping: true,
            allowTouchMove: false,
            breakpoints: {
                640: {
                    slidesPerView: 1.2,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 2.2,
                    centeredSlides: false,
                },
                1024: {
                    slidesPerView: 3.2,
                    centeredSlides: false,
                }
            },
        }
    );

    // Adding filtering
    $(filterList, (element) => {
        // return if not element
        if (!filterList || !filterList.length) return;
        // Adding event listener
        element.addEventListener('click', (e) => {
            // Prevent default event
            e.preventDefault();
            // Filtering by
            const filterBy = element.dataset.filterId;
            // Getting active slides
            const activeSlide = document.querySelector(`#project-list-trigger li a[data-filter="${filterBy}"]`);
            // Getting index to be activated
            const index = parseInt(activeSlide?.dataset?.index || 1) - 1;

            // Remove active class form filters
            $('#filter-list button').removeClass('active');
            // Adding active class to element
            element.classList.add('active');

            // show all filter items
            $('[data-filter]').hide();
            // If not all
            if (filterBy !== 'all') {
                // show only filtered items
                $(`[data-filter="${filterBy}"]`).show();
                // Slide to
                slideTo(index);
                // Detail change
                toDetail(index);
                // Remove active class for list
                $('#project-list-trigger li a').removeClass('active');
                // Set active item
                activeSlide.classList.add('active');
            }
            // If all items
            else {
                // show all filter items
                $('[data-filter]').show();
                // Slide to
                slideTo(0);
                // Detail change
                toDetail(0);
                // Remove active class for list
                $('#project-list-trigger li a').removeClass('active');
                // Set active item
                document.querySelector(`#project-list-trigger li a`).classList.add('active');
            }
        });
    });


    // Method to get reverse slide position
    const reverseSlidePosition = (index) => {
        // Getting all reverse slides
        const _slides = document.querySelectorAll('#project-vertical-slider-2 > div');
        // Getting slide height
        const slideHeight = _slides[index].offsetHeight;
        // Getting slide margins
        const margin = parseInt(window.getComputedStyle(_slides[index]).getPropertyValue('margin-bottom'));
        // Scroll Position
        return (slideHeight + margin) * index;
    };

    // Method to create reverse slider
    const createReverseSlider = () => {
        // If slider not exist
        if (!reverseSlider || !slider) return;
        // Creating reverse slider
        reverseSlider.innerHTML = slider.innerHTML;
        // Getting reverse slide position
        const position = reverseSlidePosition(1);
        // Scroll position
        reverseSlider.style.top = `-${position}px`;
        // Add active to current item
        $(slides[0]).addClass('active');
    };

    // Method to scroll vertical slider one
    const slideTo = (index) => {
        // Change swiper
        mobileSlider.slideTo(index);
        // Getting slide height
        const slideHeight = slides[index].offsetHeight;
        // Getting slide margins
        const margin = parseInt(window.getComputedStyle(slides[index]).getPropertyValue('margin-top'));
        // Scroll Position
        const position = (slideHeight + margin) * index;
        // Scroll position
        slider.style.top = `-${position}px`;
        // Remove active from all
        $(slides).removeClass('active');
        // Add active to current item
        $(slides[index]).addClass('active');
        // Get reverse slide position
        const _position = reverseSlidePosition(slides.length === index + 1 ? 0 : index + 1);
        // Set reverse slider position
        reverseSlider.style.top = `-${_position}px`;
    };

    // Change detail slide
    const toDetail = (index) => {
        // Getting detail slides
        const slides = document.querySelectorAll('#details-slider > div');
        // If slides exist
        if (slides && slides.length) {
            // Remove active class
            $(slides).removeClass('active');
            // Add Active class
            slides[index].classList.add('active');
        }
    };

    // Each project list
    $('#project-list-trigger li a', (item, index) => {
        // Adding click event to every item
        item.addEventListener('click', (e) => {
            // Prevent default event
            e.preventDefault();
            // Remove active class
            $('#project-list-trigger li a').removeClass('active');
            // Add active class to item
            $(item).addClass('active');
            // show item detail
            toDetail(index);
            // Scroll slider 1
            slideTo(index);
        })
    });

    // Creating reverse slider
    createReverseSlider();
};

// Exporting component
export default ProjectList;